import { useJurisdictionDetector as useNativeJurisdictionDetector } from '@libs/hooks';

export const useJurisdictionDetector = () =>
  useNativeJurisdictionDetector(process.env.ENVIRONMENT);
